import PropTypes from "prop-types";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { Grid } from "@material-ui/core";
import translate from "../../../../i18n/translate";
import { SrButton, SrInput, SrInputPassword, SrAlert } from "../../../common";
import { validations } from "utils";

const initialValues = {
  email: "",
  password: "",
  confirmPassword: "",
};

const validationSchema = Yup.object().shape({
  email: validations.email.required(translate("common.requiredField")),
  password: validations.password.required(translate("common.requiredField")),
  confirmPassword: validations.password
    .required(translate("common.confirmPassword"))
    .oneOf([Yup.ref("password"), null], translate("auth.passwordEmailMatch")),
});

const StepOne = ({ onSubmit, currentState }) => (
  <Formik
    initialValues={currentState || initialValues}
    validateOnChange="true"
    validationSchema={validationSchema}
    onSubmit={onSubmit}
  >
    {({ errors, handleBlur, handleChange, touched, values, isSubmitting }) => (
      <Form noValidate>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <SrInput
              label={translate("common.email")}
              required
              fullWidth
              error={Boolean(errors.email && touched.email)}
              helperText={touched.email && errors.email}
              name="email"
              type="email"
              id="email"
              autoComplete="email"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.email}
            />
          </Grid>
          <Grid item xs={12}>
            <SrInputPassword
              label={translate("common.password")}
              required
              fullWidth
              error={Boolean(errors.password && touched.password)}
              helperText={touched.password && errors.password}
              name="password"
              id="password"
              autoComplete="password"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.password}
            />
          </Grid>
          <Grid item xs={12}>
            <SrInputPassword
              label={translate("common.confirmPassword")}
              required
              fullWidth
              error={Boolean(errors.confirmPassword && touched.confirmPassword)}
              helperText={touched.confirmPassword && errors.confirmPassword}
              name="confirmPassword"
              id="confirmPassword"
              autoComplete="confirmPassword"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.confirmPassword}
            />
          </Grid>
          {errors.main && (
            <Grid item xs={12}>
              <SrAlert severity="error">{errors.main}</SrAlert>
            </Grid>
          )}
          <Grid item xs={12}>
            <SrButton
              type="submit"
              variant="contained"
              color="primary"
              disabled={isSubmitting}
            >
              {translate("auth.createAccount")}
            </SrButton>
          </Grid>
        </Grid>
      </Form>
    )}
  </Formik>
);
StepOne.defaultProps = {
  currentState: undefined,
};

StepOne.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  currentState: PropTypes.object,
};

export default StepOne;
